/* BASIQ · Captación de email: suscribe a una lista de Klaviyo (API pública de cliente) */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions?company_id=';
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setup(form) {
    if (!form || form.dataset.ready === '1') return;
    form.dataset.ready = '1';

    var wrap = form.parentNode;
    var input = form.querySelector('input[type="email"]');
    var hp = form.querySelector('input[name="website"]');
    var btn = form.querySelector('button[type="submit"]');
    var ok = wrap.querySelector('[data-nl-ok]');
    var err = wrap.querySelector('[data-nl-error]');
    var company = form.getAttribute('data-company');
    var list = form.getAttribute('data-list');
    var busy = false;

    function showError(msg) {
      if (!err) return;
      err.textContent = msg;
      err.hidden = false;
    }

    input.addEventListener('input', function () {
      input.classList.remove('is-invalid');
      if (err) err.hidden = true;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (hp && hp.value) return; /* bot */

      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        input.classList.add('is-invalid');
        showError(form.getAttribute('data-t-invalid'));
        input.focus();
        return;
      }
      if (!company || !list) {
        showError(form.getAttribute('data-t-error'));
        return;
      }

      busy = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;

      var attrs = { profile: { data: { type: 'profile', attributes: { email: email } } } };

      var body = {
        data: {
          type: 'subscription',
          attributes: attrs,
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      fetch(ENDPOINT + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (r.status >= 200 && r.status < 300) return true;
          return r.text().then(function (t) { throw new Error(t || String(r.status)); });
        })
        .then(function () {
          form.hidden = true;
          if (ok) ok.hidden = false;
          document.dispatchEvent(new CustomEvent('bp:newsletter-subscribed', { detail: { email: email } }));
        })
        .catch(function (e2) {
          if (window.console) console.warn('[BASIQ newsletter]', e2 && e2.message);
          showError(form.getAttribute('data-t-error'));
        })
        .then(function () {
          busy = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bp-newsletter]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
